import { action, computed, observable } from 'mobx';
import { IStory } from '~/components/YearInReview/2024/types/yearInReview.model';
import { RootStore } from '~/stores/root.store';

export class YearInReviewStore {
    @observable stories: Record<string, IStory> = {};
    @observable yearInReviewRawData: any;
    @observable isShowStories: boolean = true;
    @observable storiesToDisplayCount: number = 0;
    @observable isShareInProgress: boolean = false;

    rootStore: RootStore = null;

    constructor(rootStore: RootStore) {
        this.rootStore = rootStore;
    }

    @action.bound
    load(data: any) {
        this.yearInReviewRawData = data;
    }

    @action.bound
    saveStoryBlob(blob: any, dataUrl: string, name: string) {
        if (!this.stories[name]) {
            this.stories[name] = {
                blob: undefined,
                dataUrl: undefined
            };
        }

        this.stories[name].blob = blob;
        this.stories[name].dataUrl = dataUrl;
    }

    @action.bound
    setIsShowStories(isShow: boolean) {
        this.isShowStories = isShow;
    }

    @action.bound
    setStoriesToDisplayCount(count: number) {
        this.storiesToDisplayCount = count;
    }

    @action.bound
    setIsShareInProgress(isInProgress: boolean) {
        this.isShareInProgress = isInProgress;
    }

    @action.bound
    reset() {
        this.stories = {};
        this.yearInReviewRawData = {};
        this.isShowStories = true;
        this.storiesToDisplayCount = 0;
        this.isShareInProgress = false;
    }

    @computed
    get isCanadian() {
        return this.rootStore.companyStore.currCompany.isCanadian;
    }
}
